module.exports = __webpack_public_path__ + "img/nodeType4.c332a72d.svg";